import { render, staticRenderFns } from "./HighpuriNavi.vue?vue&type=template&id=4cdb97d5&"
import script from "./HighpuriNavi.vue?vue&type=script&lang=js&"
export * from "./HighpuriNavi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports